/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-17 11:28:35
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-04-29 17:43:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHeader/HeaderStyle/index.tsx
 */
import { store } from '@/src/store';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Input, RadioGroup, RadioItem } from 'src/components/Antd';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { Row } from 'src/components/Layouts';
import Switcher from 'src/components/SectionSwitcher';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import ItemWrapper from 'src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from 'src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getHeaderStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFixedFieldChange,
  resetConfig,
} from '../slice';
import {
  LogoPosition,
  PositionAlignment,
  SalesChannelEditorHeaderEnum,
  errKey,
  filter,
  headerStyleValidation,
} from '../tool';
import css from './css.module.less';
function HeaderStyle(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const p: any = useParams();
  const { saleChannelUuid } = p;
  const h = useHistory();
  const [s, setS] = useState('logoBarColor');
  const { data, specificError } = props;
  const _d = useDispatch();
  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper title={getI18n('salesChannelContent.index.logoImage')}>
          <div
            className={css.jumpContainer}
            onClick={() => {
              h.push(`/salesChannel/setting/logoManagement/${saleChannelUuid}`);
            }}>
            <ArrowRightOutlined rev className={css.icon} />
            <div>
              {getI18n('salesChannelContent.index.viewinLogoManagement')}
            </div>
          </div>
        </ItemWrapper>
      </Section>
      <Section bottomBorder>
        <ItemWrapper title={getI18n('salesChannelContent.index.logoHeight')}>
          <Input
            error={
              specificError[errKey.logoHeight] &&
              specificError[errKey.logoHeight].length !== 0
            }
            help={specificError[errKey.logoHeight]?.join('')}
            suffix={'px'}
            size={'large'}
            customFilter={filter}
            value={data.logoHeight}
            onChange={(value) => {
              _d(
                onFixedFieldChange({
                  path: 'headerStyle.logoHeight',
                  value,
                }),
              );
            }}
          />
        </ItemWrapper>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper title={getI18n('general.topPadding')}>
                  <Input
                    error={
                      specificError[errKey.topPadding] &&
                      specificError[errKey.topPadding].length !== 0
                    }
                    help={specificError[errKey.topPadding]?.join('')}
                    suffix={'px'}
                    size={'large'}
                    customFilter={filter}
                    onChange={(value) =>
                      _d(
                        onFixedFieldChange({
                          path: 'headerStyle.topPadding',
                          value,
                        }),
                      )
                    }
                    value={data.topPadding}
                  />
                </ItemWrapper>
              ),
            },
            {
              child: (
                <ItemWrapper title={getI18n('general.bottomPadding')}>
                  <Input
                    error={
                      specificError[errKey.bottomPadding] &&
                      specificError[errKey.bottomPadding].length !== 0
                    }
                    help={specificError[errKey.bottomPadding]?.join('')}
                    suffix={'px'}
                    size={'large'}
                    customFilter={filter}
                    value={data.bottomPadding}
                    onChange={(value) =>
                      _d(
                        onFixedFieldChange({
                          path: 'headerStyle.bottomPadding',
                          value,
                        }),
                      )
                    }
                  />
                </ItemWrapper>
              ),
            },
          ]}
        />
      </Section>
      <Section bottomBorder>
        <ItemWrapper title={getI18n('salesChannelContent.index.logoPosition')}>
          <RadioGroup
            value={data.logoPosition}
            onChange={(e: any) => {
              _d(
                onFixedFieldChange({
                  path: 'headerStyle.logoPosition',
                  value: e.target.value,
                }),
              );
            }}>
            <Space direction='vertical'>
              <>
                <RadioItem value={LogoPosition.CENTER}>
                  {getI18n('salesChannelContent.index.center')}
                </RadioItem>
                <RadioItem value={LogoPosition.LEFT}>
                  {getI18n('salesChannelContent.index.left')}
                </RadioItem>
              </>
            </Space>
          </RadioGroup>
        </ItemWrapper>
      </Section>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n(
            'salesChannelContent.index.firstModulePositionAlignment',
          )}
          bottomTitle={getI18n('salesChannelContent.index.tipbannerheight')}>
          <RadioGroup
            value={data.positionAlignment}
            onChange={(e: any) => {
              _d(
                onFixedFieldChange({
                  path: 'headerStyle.positionAlignment',
                  value: e.target.value,
                }),
              );
            }}>
            <Space direction='vertical'>
              <>
                <RadioItem value={PositionAlignment.TOP_OF_PAGE}>
                  {getI18n('salesChannelContent.index.topofthepage')}
                </RadioItem>
                <RadioItem value={PositionAlignment.UNDER_LOGO}>
                  {getI18n('salesChannelContent.index.underlogobar')}
                </RadioItem>
                <RadioItem value={PositionAlignment.UNDER_MENU}>
                  {getI18n('salesChannelContent.index.undermenubar')}
                </RadioItem>
              </>
            </Space>
          </RadioGroup>
        </ItemWrapper>
      </Section>
      <Section bottomBorder>
        <Switcher
          selected={s}
          onChange={(v) => setS(v)}
          allSections={{
            logoBarColor: {
              title: getI18n('salesChannelContent.index.logoBarColour'),
              hasError: false,
              child: (
                <React.Fragment>
                  <ItemWrapper title={getI18n('general.backgroundColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'headerStyle.logoBarColor.backgroundColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.logoBarColor?.backgroundColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n('salesChannelContent.index.textIconColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'headerStyle.logoBarColor.textColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.logoBarColor?.textColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n('salesChannelContent.index.dividerColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'headerStyle.logoBarColor.dividerColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.logoBarColor?.dividerColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n(
                      'salesChannelContent.index.languageSelectorOutlineColour',
                    )}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'headerStyle.logoBarColor.outlineColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.logoBarColor?.outlineColor}
                    />
                  </ItemWrapper>
                </React.Fragment>
              ),
            },
            menuBarColor: {
              title: getI18n('salesChannelContent.index.menuBarColour'),
              hasError: false,
              child: (
                <React.Fragment>
                  <ItemWrapper title={getI18n('general.backgroundColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'headerStyle.menuBarColor.backgroundColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.menuBarColor?.backgroundColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper title={getI18n('general.textColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'headerStyle.menuBarColor.textColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.menuBarColor?.textColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n(
                      'salesChannelContent.index.searchBarOutlineColour',
                    )}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'headerStyle.menuBarColor.outlineColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.menuBarColor?.outlineColor}
                    />
                  </ItemWrapper>
                </React.Fragment>
              ),
            },
          }}
        />
      </Section>
    </React.Fragment>
  );
}

export default (props) =>
  ErrorProcessingHOC(HeaderStyle, {
    getCollapseOpenStatus,
    onCollapseOpen,
    expandOffset: props.isResponsive ? 0 : undefined,
    id: SalesChannelEditorHeaderEnum.headerStyle,
    getContent: getHeaderStyle,
    title: getI18nFromGeneral('general.hOCTitle.headerStyle'),
    getErrorDisplay: getCollapseValidationMsgDisplay,
    onErrorChange,
    getSubmitStamp,
    validation: (x) => {
      return headerStyleValidation(x);
    },
    headerProps: {
      dotsFunction: [
        {
          onClick: () => {
            store.dispatch(resetConfig({ key: 'headerStyle' }));
          },
          key: 'Reset Style',
          body: getI18nFromGeneral('general.hOCTitle.resetStyle'),
          isDangerous: true,
        },
      ],
      hasDots: true,
      hideDotsWhenNotPrimary: true,
    },
  })(props);
